import { FormControl, Grid, IconButton, InputLabel, Select, TextField, Autocomplete
    , Typography, Stack, Box, Checkbox, FormControlLabel  } from '@mui/material';
import { Search as IconSearch, Edit as IconEdit, AddCircle as IconAddCircle } from "@mui/icons-material";
import api from "../services/api";
import moment from 'moment';
import React, { useCallback, useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { init as initAreaObjective, setEntity, setData, setValidationMessage, activeValidations
  , setListArea, setListDestreza, defaultAreaObjective} from "../redux/areaObjectiveSlice";
import { FormHelperText as HelperText } from '@mui/material';
import Skill from './Skill';
import SkillEdit from './SkillEdit';

const AreaObjective = (props) => {
    const isReadOnly = props.isReadOnly;
    const dispatch = useDispatch();
    const sliceKey = props.sliceKey;
    const inputRef = useRef(null);

    useEffect(() => {
        dispatch(initAreaObjective({ sliceKey }));
    }, [dispatch, sliceKey]);

    useEffect(() => {
        if (props.autoFocus) {
        const timer = setTimeout(() => inputRef.current?.focus(), 150);
        return () => clearTimeout(timer);
        }
    }, [props.autoFocus]);

    const entity = useSelector((state) => state.areaObjective[sliceKey].entity);
    const listArea = useSelector((state) => state.areaObjective[sliceKey].listArea);
    const listDestreza = useSelector((state) => state.areaObjective[sliceKey].listDestreza);
    const validate = useSelector((state) => state.areaObjective[sliceKey].validationActive);
    const [selectIdDestreza, setSelectIdDestreza] = useState(null);
    const [openSkillEdit, setOpenSkillEdit] = useState(false)
    const openCloseSkillEdit = () => { setOpenSkillEdit(!openSkillEdit); }

    var validation = {
        idArea: {
            error: entity.idArea == 0 || entity.idArea == null,
            message: "Falta ingresar el area",
        },
        idDestreza: {
            error: entity.idDestreza == 0 || entity.idDestreza == null,
            message: "Falta ingresar la destreza",
        },
        codigo: {
            error: entity.codigo.length < 1,
            message: "Falta ingresar el codigo del objetivo",
        },
        nombre: {
            error: entity.nombre.length < 1,
            message: "Falta ingresar el nombre del objetivo",
        },
        orden: {
            error: entity.orden < 0,
            message: "Ingrese un número de orden válido",
        },
    }

    const fetchEntity = useCallback(async () => {
        const response = await api.get("/Modelo/GetAreaObjetivo?idAreaObjetivo=" + props.id)
            .catch((err) => {
                console.log("Err: ", err);
            });

        if (props.id == 0){
            dispatch(setEntity({sliceKey: sliceKey, data: defaultAreaObjective}));
            console.log(props.idArea)
            console.log(props.area)
            dispatch(setData({sliceKey: sliceKey, name: "idArea", value: props.idArea}));
            dispatch(setData({sliceKey: sliceKey, name: "area", value: props.area}));
        }
        else {
            dispatch(setEntity({sliceKey: sliceKey, data: response.data.data}));
        }
    }, [])
    const fetchArea = useCallback(async () => {
        const response = await api.get("/Modelo/GetsListArea?idModelo=" + props.idModelo)
            .catch((err) => {
                console.log("Err: ", err);
            });

        dispatch(setListArea({sliceKey: sliceKey, data: response.data.data}));
    }, [])
    const fetchDestreza = useCallback(async () => {
        const response = await api.get("/Modelo/GetsListDestreza")
            .catch((err) => {
                console.log("Err: ", err);
            });

        dispatch(setListDestreza({sliceKey: sliceKey, data: response.data.data}));
    }, [])

    useEffect(() => {
        fetchEntity();
        fetchArea();
        fetchDestreza();
        dispatch(setValidationMessage({sliceKey: sliceKey, message: messagesValidation()}));
    }, []);

    useEffect(() => {
        dispatch(setValidationMessage({sliceKey: sliceKey, message: messagesValidation()}));
    }, [entity])

    var setDataEntity = e => {
        dispatch(setData({sliceKey: sliceKey, name: e.target.name, value: e.target.value}));
    }
    const setNewSkill = (id, name) => {
        fetchDestreza();

        dispatch(setData({sliceKey: sliceKey, name: "idDestreza", value: id || 0}))
        dispatch(setData({sliceKey: sliceKey, name: "destreza", value: name || ""}))
    }

    const messagesValidation = () => {
        var messages = [];

        Object.keys(validation).forEach(function (key) {
            if (validation[key].error) messages.push(validation[key].message)
        })

        return messages;
    }

    return (
        <Grid container>
            {/* {JSON.stringify(validation)}
            {JSON.stringify(validate)} */}
            {/* {JSON.stringify(entity)} */}
            <Grid item>
                <Box sx={{ fontWeight: 'bold' }} padding={0}>
                    <Typography variant="h7">
                        Datos Basicos
                    </Typography>
                </Box>
            </Grid>
            <Grid container spacing={1} padding={"12px 0px 0px 0px"}>
                <Grid item xs={12} sm={5}>
                    {/* <FormControl required fullWidth error={validate?.idArea && validation.idArea.error}>
                        <InputLabel htmlFor="input-area">Area</InputLabel>
                        <Select
                            native
                            label="Area"
                            value={entity?.idArea}
                            onChange={(event) => {
                                var id = event.nativeEvent.target.selectedIndex;
                                
                                dispatch(setData({sliceKey: sliceKey, name: "idArea", value: event.target.value}))
                                dispatch(setData({sliceKey: sliceKey, name: "area", value: event.nativeEvent.target[id].text}))
                            }}
                            inputProps={{
                                name: 'idArea',
                                id: 'input-area',
                            }}
                            size="small"
                        >
                            <option key={0} value={0}>{"(Seleccione)"}</option>
                            {listArea?.map((row) => (
                                <option key={row.id} value={row.id}>{row.descripcion}</option>
                            ))}
                        </Select>
                        <HelperText>
                            {validate?.idArea && validation.idArea.error ? validation.idArea.message : ""}
                        </HelperText>
                    </FormControl> */}
                    <FormControl required fullWidth>
                        <Autocomplete
                            name="idArea"
                            value={listArea.find(x => x.id === entity.idArea) || null}
                            inputValue={entity.area || ""}
                            onInputChange={(event, newValue) => {
                                if (event != null) {
                                    if (event.type === "change") {
                                        dispatch(setData({sliceKey: sliceKey, name: "area", value: newValue || ""}))
                                        // dispatch(setData({name: "colegio", value: newValue || ""}))
                                    }
                                }
                            }}
                            onChange={(event, newValue) => {
                                dispatch(setData({sliceKey: sliceKey, name: "idArea", value: newValue?.id ?? 0}))
                                dispatch(setData({sliceKey: sliceKey, name: "area", value: newValue?.descripcion ?? ""}))
                                // dispatch(setData({name: "idColegio", value: newValue?.id ?? 0}))
                                // dispatch(setData({name: "colegio", value: newValue?.descripcion ?? ""}))
                            }}
                            options={listArea}
                            autoHighlight
                            disabled={isReadOnly}
                            getOptionLabel={(option) => option.descripcion || ""}
                            isOptionEqualToValue ={(option, value) => option.value === value.value}
                            renderOption={(props, option) => {
                                return (
                                    <li {...props} key={option.id}>
                                    {option.descripcion}
                                    </li>
                                );
                                }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Area"
                                    variant="outlined"
                                    inputProps={{
                                        ...params.inputProps,
                                        autoComplete: 'new-password',
                                    }}
                                />
                            )}
                            size="small"
                        />
                        {/* <HelperText>{validate.terapeuta && validation.terapeuta.error ? validation.terapeuta.message : ""}</HelperText> */}
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={5}>
                    <Box display="flex" alignItems="center" gap={0}>
                        <FormControl required fullWidth>
                            <Autocomplete
                                name="idDestreza"
                                value={listDestreza.find(x => x.id === entity.idDestreza) || null}
                                inputValue={entity.destreza || ""}
                                onInputChange={(event, newValue) => {
                                    dispatch(setData({ sliceKey: sliceKey, name: "destreza", value: newValue || "" }))

                                    const match = listDestreza.find(
                                        x => x.descripcion.toLowerCase() === (newValue || "").toLowerCase()
                                    )

                                    if (!match) {
                                        dispatch(setData({ sliceKey: sliceKey, name: "idDestreza", value: 0 }))
                                    }
                                }}
                                onChange={(event, newValue) => {
                                    dispatch(setData({sliceKey: sliceKey, name: "idDestreza", value: newValue?.id ?? 0}))
                                    dispatch(setData({sliceKey: sliceKey, name: "destreza", value: newValue?.descripcion ?? ""}))
                                    setSelectIdDestreza(newValue?.id ?? 0)
                                }}
                                options={listDestreza}
                                autoHighlight
                                disabled={isReadOnly}
                                getOptionLabel={(option) => option.descripcion || ""}
                                isOptionEqualToValue ={(option, value) => option.id === value.id}
                                renderOption={(props, option) => {
                                    return (
                                        <li {...props} key={option.id}>
                                        {option.descripcion}
                                        </li>
                                    );
                                    }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Destreza"
                                        variant="outlined"
                                        inputProps={{
                                            ...params.inputProps,
                                            autoComplete: 'new-password',
                                        }}
                                    />
                                )}
                                size="small"
                            />
                        </FormControl>
                        {/* <TextField
                            name="destreza"
                            label="Destreza"
                            fullWidth
                            value={entity?.destreza || ""}
                            onChange={setDataEntity}
                            disabled
                            size="small"
                            InputLabelProps={{ shrink: true }}
                        /> */}
                        <IconButton aria-label="editar destreza" size='small' disabled={isReadOnly} onClick={() => {
                            setSelectIdDestreza(entity.idDestreza)
                            openCloseSkillEdit()
                            }}>
                            {entity.idDestreza > 0 ? <IconEdit /> : <IconAddCircle />}
                        </IconButton>
                    </Box>
                    {/* <FormControl required fullWidth error={validate?.idDestreza && validation.idDestreza.error}>
                        <InputLabel htmlFor="input-destreza">Destreza</InputLabel>
                        <Select
                            native
                            label="Destreza"
                            value={entity?.idDestreza}
                            onChange={(event) => {
                                var id = event.nativeEvent.target.selectedIndex;
                                
                                dispatch(setData({sliceKey: sliceKey, name: "idDestreza", value: event.target.value}))
                                dispatch(setData({sliceKey: sliceKey, name: "destreza", value: event.nativeEvent.target[id].text}))
                            }}
                            inputProps={{
                                name: 'idDestreza',
                                id: 'input-destreza',
                            }}
                            size="small"
                        >
                            <option key={0} value={0}>{"(Seleccione)"}</option>
                            {listDestreza?.map((row) => (
                                <option key={row.id} value={row.id}>{row.descripcion}</option>
                            ))}
                        </Select>
                        <HelperText>
                            {validate?.idDestreza && validation.idDestreza.error ? validation.idDestreza.message : ""}
                        </HelperText>
                    </FormControl> */}
                </Grid>
                <Grid item xs={4} sm={2}>
                    <TextField
                        required
                        name="codigo"
                        label="Codigo"
                        fullWidth
                        value={entity?.codigo}
                        onChange={setDataEntity}
                        disabled={isReadOnly}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>
                <Grid item xs={12} sm={12}>
                    <TextField
                        name="nombre"
                        label="Nombre"
                        fullWidth
                        value={entity?.nombre}
                        onChange={setDataEntity}
                        disabled={isReadOnly}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>
                <Grid item xs={12} sm={12}>
                    <TextField
                        name="descripcion"
                        label="Descripción"
                        fullWidth
                        value={entity?.descripcion}
                        onChange={setDataEntity}
                        disabled={isReadOnly}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>
                <Grid item xs={4} sm={2}>
                    <TextField
                        name="orden"
                        label="Orden"
                        type='number'
                        fullWidth
                        value={entity?.orden}
                        onChange={setDataEntity}
                        disabled={isReadOnly}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>
            </Grid>
            <SkillEdit id={selectIdDestreza} sliceKey="skillEdit" open={openSkillEdit} openClose={openCloseSkillEdit} setNewSkillSaved={setNewSkill} isReadOnly={isReadOnly} />
        </Grid>
    );
}
export default AreaObjective;
